import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_USERS = restRequest(
    "VRCORE_DASHBOARD_COMPONENTS.TOTAL_CLIENT_INFO_WIDGET.GET_USERS"
);
export const GET_QR_LIST = restRequest(
    "VRCORE_DASHBOARD_COMPONENTS.TOTAL_CLIENT_INFO_WIDGET.GET_QR_LIST"
);
export const GET_BUILD_DATA = restRequest(
    "VRCORE_DASHBOARD_COMPONENTS.TOTAL_CLIENT_INFO_WIDGET.GET_BUILD_DATA"
);
export const SET_ENV_BUILD =
    "VRCORE_DASHBOARD_COMPONENTS.TOTAL_CLIENT_INFO_WIDGET.SET_ENV_BUILD";
export const GET_JOB_PACKS = restRequest(
        "VRCORE_DASHBOARD_COMPONENTS.TOTAL_CLIENT_INFO_WIDGET.GET_JOB_PACKS"
    );